import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@app/core/models/app-config';
import { AppInfo } from '@app/core/models/app-info';
import { constructRestUrl } from '@util/url';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AppConfigService {

  constructor(private http: HttpClient) {
  }

  fetchConfig(): Observable<AppConfig> {
    return this.http.get<AppConfig>('config/startup-config.json');
  }

  fetchAppInfo(): Observable<AppInfo> {
    return this.http.get(constructRestUrl('appLoginInfo')).pipe(
      map((response: any): AppInfo => {
        const info = response;

        return {
          url: info.url,
          name: info.name,
          version: info.version,
          documentation: info.documentation,
          releaseDate: info.releaseDate,
          ipDocumentation: info.ipDocumentation,
          wsVersion: info.wsVersion,
          legalNoticeUrl: info.legalNoticeUrl,
          mailPcsSupport: info.mailPcsSupport,
          requestNewAccountUrl: info.requestNewAccountUrl,
          requestPasswordChangeUrl: info.requestPasswordChangeUrl
        };
      }));
  }

}
